import React from "react";

export default function TermsOfService() {
    return (
        <div style={{ height: "100vh" }}>
            <iframe
                src="/docs/terms_of_service.pdf"
                title="Пользовательское соглашение"
                width="100%"
                height="100%"
                style={{ border: "none" }}
            />
        </div>
    );
}
